import { render } from "./SasTokenAuth.vue?vue&type=template&id=5672caba"
import script from "./SasTokenAuth.vue?vue&type=script&lang=js"
export * from "./SasTokenAuth.vue?vue&type=script&lang=js"

import "./SasTokenAuth.vue?vue&type=style&index=0&id=5672caba&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__